import { Component, OnDestroy, OnInit } from '@angular/core';
import { InitializerService } from '@atumverse/core-services';

@Component({
  selector: 'web-app-layout',
  templateUrl: './web-app-layout.component.html',
  styleUrls: ['./web-app-layout.component.scss']
})
export class WebAppLayoutComponent implements OnInit, OnDestroy {

  constructor(
    private initializerService: InitializerService,
  ) {
    this.initializerService.resetApp();
  }

  ngOnInit() {

  }

  ngOnDestroy() {

  }
}
